import { ImageProps as NextImageProps } from 'next/image';
import { isValidImageSrc } from 'core/common/utils/isValidImageSrc';
import { ImageStyled } from './styled';

type SpacingValue = number | string;

type ImageProps = NextImageProps & {
  m?: SpacingValue;
  mt?: SpacingValue;
  mb?: SpacingValue;
  ml?: SpacingValue;
  mr?: SpacingValue;
  mx?: SpacingValue;
  my?: SpacingValue;
};

// A `vw` sizes keeps only the srcset candidates >= deviceSizes[0] * ratio, and every app's
// deviceSizes has one entry above 2x the largest imageSizes bucket. So a CMS image resolves to
// one optimizer url regardless of its rendered width, which is what lets the next-screen
// preloader request exactly the url the consumer will request.
const cmsImageSizes = '50vw';

export const Image = (props: ImageProps) => {
  const { src } = props;

  if (typeof src !== 'string') {
    return <ImageStyled {...props} />;
  }

  // CMS content can deliver an unresolved template as src; next/image throws on it and takes the whole screen down
  if (!isValidImageSrc(src)) {
    return null;
  }

  return <ImageStyled {...props} sizes={cmsImageSizes} />;
};
